module.exports = __webpack_public_path__ + "img/treble.f39f8b14.png";